import * as types from '../mutation-types';
import config from '@/config';
import { loadDataForSnapshot } from '@/utils/loading';


const state = {
  userData: {},
};

const mutations = {
  [types.SET_USER_DATA]: (state, userData) => {
    state.userData = userData;
  },
};

const getters = {
  getUserData: state => state.userData,
  isUserInstaller: state => state.userData
    && (state.userData.enable_instaler_level || state.userData.superuser)
    && state.userData.show_instaler_level,
  isSuperuser: state => state.userData && state.userData.superuser,
};

const actions = {
  async loadUserData({ commit, rootState }) {
    await loadDataForSnapshot(
      commit, rootState, types.SET_USER_DATA, config.ICOOL.API.USER_DATA_PATH,
    );
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
